import React, { useState } from 'react';
import { Container, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faChevronRight, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const ranksData = {
  CRPF: {
    officerRanks: ['Director General', 'Special DG', 'Additional DG', 'Inspector General', 'Deputy Inspector General', 'Commandant', 'Second-in-Command', 'Deputy Commandant', 'Assistant Commandant'],
    belowOfficerRanks: ['Inspector', 'Sub-Inspector', 'Assistant Sub-Inspector', 'Head Constable', 'Constable'],
    belowOfficerLabel: 'Subordinate & Other',
  },
  BSF: {
    officerRanks: ['Director General', 'Special DG', 'Additional DG', 'Inspector General', 'Deputy Inspector General', 'Commandant', 'Second-in-Command', 'Deputy Commandant', 'Assistant Commandant'],
    belowOfficerRanks: ['Inspector', 'Sub-Inspector', 'Assistant Sub-Inspector', 'Head Constable', 'Constable'],
    belowOfficerLabel: 'Subordinate & Other',
  },
  CISF: {
    officerRanks: ['Director General', 'Additional DG', 'Inspector General', 'Deputy Inspector General', 'Senior Commandant', 'Commandant', 'Deputy Commandant', 'Assistant Commandant'],
    belowOfficerRanks: ['Inspector', 'Sub-Inspector', 'Assistant Sub-Inspector', 'Head Constable', 'Constable/Fire Constable'],
    belowOfficerLabel: 'Subordinate & Other',
  },
  ITBP: {
    officerRanks: ['Director General', 'Additional DG', 'Inspector General', 'Deputy Inspector General', 'Commandant', 'Second-in-Command', 'Deputy Commandant', 'Assistant Commandant'],
    belowOfficerRanks: ['Inspector', 'Sub-Inspector', 'Assistant Sub-Inspector', 'Head Constable', 'Constable'],
    belowOfficerLabel: 'Subordinate & Other',
  },
  SSB: {
    officerRanks: ['Director General', 'Additional DG', 'Inspector General', 'Deputy Inspector General', 'Commandant', 'Second-in-Command', 'Deputy Commandant', 'Assistant Commandant'],
    belowOfficerRanks: ['Inspector', 'Sub-Inspector', 'Assistant Sub-Inspector', 'Head Constable', 'Constable'],
    belowOfficerLabel: 'Subordinate & Other',
  },
  AssamRifles: {
    officerRanks: ['Commandant', 'Second-in-Command', 'Deputy Commandant', 'Assistant Commandant'],
    belowOfficerRanks: ['Subedar Major', 'Subedar', 'Naib Subedar', 'Havildar', 'Rifleman'],
    belowOfficerLabel: 'Other',
  },
};

const Ranks = () => {
  const [selectedForce, setSelectedForce] = useState('');
  const [selectedRankType, setSelectedRankType] = useState('');
  const [ranks, setRanks] = useState([]);

  const handleForceChange = (e) => {
    setSelectedForce(e.target.value);
    setSelectedRankType('');
    setRanks([]); 
  };

  const handleRankTypeChange = (e) => {
    const value = e.target.value;
    setSelectedRankType(value);

    if (value === 'Officer') {
      setRanks(ranksData[selectedForce]?.officerRanks || []);
    } else if (value === 'Below Officer') {
      setRanks(ranksData[selectedForce]?.belowOfficerRanks || []);
    }
  };

  const getRankTypeLabel = () => {
    if (selectedRankType === 'Officer') return 'Officer';
    return ranksData[selectedForce]?.belowOfficerLabel || 'Subordinate & Other';
  };

  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faMedal} className="me-2" />
            CAPF Ranks Structure
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
              Select Force and Rank Type
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="row mb-4">
              <div className="col-md-6 mb-3">
                <label htmlFor="forceSelect" className="form-label fw-bold" style={{ color: '#1e3c72' }}>
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
                  Force
                </label>
                <select
                  id="forceSelect"
                  value={selectedForce}
                  onChange={handleForceChange}
                  className="form-control"
                  style={{ 
                    borderRadius: '10px',
                    padding: '12px',
                    border: '2px solid #e9ecef'
                  }}
                >
                  <option value="">--Select a Force--</option>
                  <option value="CRPF">CRPF (Central Reserve Police Force)</option>
                  <option value="BSF">BSF (Border Security Force)</option>
                  <option value="CISF">CISF (Central Industrial Security Force)</option>
                  <option value="ITBP">ITBP (Indo-Tibetan Border Police)</option>
                  <option value="SSB">SSB (Sashastra Seema Bal)</option>
                  <option value="AssamRifles">Assam Rifles</option>
                </select>
              </div>

              {selectedForce && (
                <div className="col-md-6 mb-3">
                  <label htmlFor="rankTypeSelect" className="form-label fw-bold" style={{ color: '#1e3c72' }}>
                    <FontAwesomeIcon icon={faMedal} className="me-2" />
                    Rank Type
                  </label>
                  <select
                    id="rankTypeSelect"
                    value={selectedRankType}
                    onChange={handleRankTypeChange}
                    className="form-control"
                    style={{ 
                      borderRadius: '10px',
                      padding: '12px',
                      border: '2px solid #e9ecef'
                    }}
                  >
                    <option value="">--Select Rank Type--</option>
                    <option value="Officer">Officer</option>
                    <option value="Below Officer">
                      {ranksData[selectedForce]?.belowOfficerLabel || 'Subordinate & Other'}
                    </option>
                  </select>
                </div>
              )}
            </div>

            {selectedRankType && ranks.length > 0 && (
              <div style={{
                background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
                borderRadius: '15px',
                padding: '25px',
                borderLeft: '4px solid #1e3c72'
              }}>
                <h5 className="fw-bold mb-3" style={{ color: '#1e3c72' }}>
                  <FontAwesomeIcon icon={faMedal} className="me-2" />
                  {getRankTypeLabel()} Ranks
                </h5>
                <ListGroup flush>
                  {ranks.map((rank, index) => (
                    <ListGroupItem 
                      key={index} 
                      className="px-0 py-2 border-0"
                      style={{ background: 'transparent' }}
                    >
                      <div className="d-flex align-items-center">
                        <div style={{
                          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                          color: 'white',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.8rem',
                          fontWeight: 'bold',
                          marginRight: '15px',
                          flexShrink: 0
                        }}>
                          {index + 1}
                        </div>
                        <span style={{ color: '#495057', fontWeight: '500' }}>
                          {rank}
                        </span>
                        <FontAwesomeIcon 
                          icon={faChevronRight} 
                          className="ms-auto" 
                          style={{ color: '#1e3c72', opacity: 0.5 }}
                        />
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </div>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Ranks;
